export const apiUrl = {
  // Auth
  login: "auth/login",
  generate_token: "auth/regenerate-token",
  forget_password: "auth/forget-password",
  logout: "auth/logout",

  // Accounts
  generate_pay_slip: "account/generate-pay-slip?",
  create_voucher: "account/create-voucher",
  get_voucher: "account/get-voucher?",
  get_voucher_details: "account/get-voucher-details",
  update_voucher: "account/update-voucher",
  delete_voucher: "account/delete-voucher",
  increase_site_budget: "account/increase-site-budget",
  get_site_budget_request: "account/get-site-budget-request?",
  create_site_budget_request: "account/create-site-budget-request",
  update_site_budget_request: "account/update-site-budget-request",
  get_site_budget_request_detail: "account/get-site-budget-request-detail?",
  update_site_budget_request_status:
    "account/update-site-budget-request-status?",
  create_workOrder: "account/create-work-order",
  get_workOrder: "account/get-work-order",
  get_work_order_detail: "account/get-work-order-detail",
  get_work_order_item: "account/get-work-order-item",
  update_workOrder: "account/update-work-order",
  create_invoice: "account/create-invoice",
  get_invoice: "account/get-invoice",
  get_invoice_detail: "account/get-invoice-detail",
  update_invoice: "account/update-invoice",
  delete_invoice: "account/delete-invoice",
  delete_invoice_item: "account/delete-invoice-item",
  generate_invoice: "account/generate-invoice",
  create_transaction: "account/create-transaction",
  get_transaction: "account/get-transaction",
  get_transaction_detail: "account/get-transaction-detail",
  update_transaction: "account/update-transaction",
  delete_transaction: "account/delete-transaction",
  create_payment_ticket: "account/create-payment-ticket",
  get_payment_ticket: "account/get-payment-ticket?",
  get_payment_ticket_details: "account/get-payment-ticket-detail?",
  update_payment_ticket: "account/update-payment-ticket",
  update_payment_ticket_status: "account/update-payment-ticket-status",
  update_only_payment_status: "account/update-only-payment-status",
  update_payment_ticket_tds: "account/update-payment-ticket-tds",
  delete_payment_ticket: "account/delete-payment-ticket",
  create_salary_head: "account/create-salary-head",
  get_salary_head: "account/get-salary-head?",
  get_salary_head_detail: "account/get-salary-head-detail",
  update_salary_head: "account/update-salary-head",
  delete_salary_head: "account/delete-salary-head",
  create_site_salary_head: "account/create-site-salary-head",
  get_site_salary_head: "account/get-site-salary-head",
  get_site_salary_head_detail: "account/get-site-salary-head-detail",
  update_site_salary_head: "account/update-site-salary-head",
  delete_site_salary_head: "account/delete-site-salary-head",
  create_user_salary: "account/create-user-salary",
  get_user_salary: "account/get-user-salary",
  update_user_salary: "account/update-user-salary",
  create_monthly_user_salary: "account/create-monthly-user-salary",
  accept_monthly_user_salary: "account/accept-monthly-user-salary",
  create_monthly_user_salary_view: "account/create-monthly-user-salary-preview",
  get_locked_user_salary: "account/get-monthly-user-salary-preview",
  get_monthly_user_salary: "account/get-monthly-user-salary",
  get_sites_for_team_payslip: "account/get-sites-for-team-payslip",
  get_site_wise_user_salary: "account/get-site-wise-user-salary",
  download_sample_voucher_excel: "account/download-sample-voucher-excel",
  update_monthly_user_salary_preview: "account/update-monthly-user-salary-preview",
  import_invoice_data: "account/import-invoice-data",
  export_payment_ticket: "account/export-payment-ticket",
  upload_payment_ticket_invoice: "account/upload-payment-ticket-invoice",
  create_bulk_vouchers: "account/create-bulk-vouchers",
  get_customer_dashboard_stats: "account/get-customer-dashboard-stats",
  recalculate_due_days: "account/recalculate-due-days",
  get_office_salary_head: "account/get-office-salary-head",
  get_office_salary_head_detail: "account/get-office-salary-head-detail",
  create_office_salary_head: "account/create-office-salary-head",
  update_office_salary_head: "account/update-office-salary-head",
  delete_office_salary_head: "account/delete-office-salary-head",

  // HRM
  add_company: "hrm/add-company",
  get_company: "hrm/get-company",
  delete_company: "hrm/delete-company",
  add_shift: "hrm/add-shift",
  get_shift: "hrm/get-shift",
  update_shift: "hrm/update-shift",
  delete_shift: "hrm/delete-shift",
  get_department: "hrm/get-department",
  get_designation: "hrm/get-designation",
  add_employee: "hrm/add-employee",
  get_employee: "hrm/get-employee",
  add_documents: "hrm/add-documents",
  add_previous_work: "hrm/add-previousWork",
  get_offer_letter: "hrm/generate-offer-letter",
  add_leave_setting: "hrm/add-leave-setting",
  get_leave_setting: "hrm/get-leave-setting",
  update_leave_setting: "hrm/update-leave-setting",
  delete_leave_setting: "hrm/delete-leave-setting",
  add_holiday: "hrm/add-holiday",
  get_holiday: "hrm/get-holiday",
  delete_holiday: "hrm/delete-holiday",
  lock_attendance: "hrm/lock-attendance",
  transfer_employee: "hrm/transfer-employee",
  create_salary_ticket: "hrm/create-salary-ticket",
  get_salary_ticket: "hrm/get-salary-ticket?",
  get_salary_ticket_detail: "hrm/get-salary-ticket-detail?",
  update_salary_ticket: "hrm/update-salary-ticket",
  update_salary_ticket_status: "hrm/update-salary-ticket-status",
  delete_salary_ticket: "hrm/delete-salary-ticket",
  generate_salary_ticket: "hrm/generate-salary-ticket",
  get_transfer_requests: "hrm/get-transfer-requests",
  delete_transfer_request: "hrm/delete-transfer-request",

  // SCM
  get_expense_head_type: "scm/get-expensehead-type",
  add_expense_head: "scm/add-expensehead",
  get_expense_head: "scm/get-expensehead",
  update_expense_head: "scm/update-expensehead",
  add_items: "scm/add-item",
  get_items: "scm/get-item?",
  get_item_stock_across_sites: "scm/get-item-stock-across-sites?",
  update_items: "scm/update-item",
  delete_items: "scm/delete-item",
  create_vendor: "scm/create-vendor",
  get_vendor: "scm/get-vendor-list",
  get_vendor_details: "scm/get-vendor-detail",
  update_vendor: "scm/update-vendor",
  update_vendor_status: "scm/update-vendor-status",
  delete_vendor: "scm/delete-vendor",
  get_vendor_analytics: "scm/get-vendor-analytics",
  create_purchase_request: "scm/create-purchase-request",
  get_purchase_request: "scm/get-purchase-request",
  get_purchase_request_detail: "scm/get-purchase-request-detail",
  update_purchase_request: "scm/update-purchase-request",
  update_purchase_request_status: "scm/update-purchase-request-status",
  delete_purchase_request: "scm/delete-purchase-request",
  get_expense_head_budget_request: "scm/get-expensehead-for-budget-request",
  get_item_budget_request: "scm/get-item-for-budget-request?",
  delete_site_budget_request: "account/delete-site-budget-request",
  create_purchase: "scm/create-purchase",
  get_purchase: "scm/get-purchase?",
  get_purchase_detail: "scm/get-purchase-detail?",
  get_purchase_item: "scm/get-purchase-item",
  update_purchase: "scm/update-purchase",
  generate_purchase_order: "scm/generate-purchase-order?",
  generate_payment_advisory: "scm/generate-payment-advisory",
  add_machinery: "scm/add-machinery",
  get_machinery: "scm/get-machinery",
  get_machinery_detail: "scm/get-machinery-detail",
  update_machinery: "scm/update-machinery",
  delete_machinery: "scm/delete-machinery",
  add_machinery_reading: "scm/add-machinery-reading",
  get_machinery_reading: "scm/get-machinery-reading",
  delete_machinery_reading: "scm/delete-machinery-reading",
  add_machinery_document: "scm/add-machinery-document",
  get_machinery_document: "scm/get-machinery-document",
  delete_machinery_document: "scm/delete-machinery-document",
  add_machinery_service: "scm/add-machinery-service",
  get_machinery_service: "scm/get-machinery-service",
  delete_machinery_service: "scm/delete-machinery-service",
  get_maintenance_dashboard: "scm/get-maintenance-dashboard",
  get_stock: "scm/get-stock",
  create_GRN: "scm/create-grn",
  get_GRN: "scm/get-grn?",
  get_grn_item: "scm/get-grn-item?",
  get_GRN_detail: "scm/get-grn-detail?",
  update_GRN: "scm/update-grn",
  update_GRN_ststus: "scm/update-grn-status",
  delete_GRN: "scm/delete-grn",
  create_stock_out: "scm/create-stock-out ",
  get_stock_out: "scm/get-stock-out?",
  get_stock_out_detail: "scm/get-stock-out-detail",
  update_stock_out: "scm/update-stock-out",
  update_stock_out_status: "scm/update-stock-out-status",
  delete_stock_out: "scm/delete-stock-out",
  create_transfer_asset: "scm/create-transfer-asset",
  get_transfer_asset: "scm/get-transfer-asset",
  get_transfer_asset_detail: "scm/get-transfer-asset-detail",
  update_transfer_asset: "scm/update-transfer-asset",
  delete_transfer_asset: "scm/delete-transfer-asset",

  // Site
  add_customer: "site/add-customer",
  get_customer: "site/get-customer",
  get_customer_detail: "site/get-customer-detail",
  Update_Customer: "site/edit-customer",
  delete_customer: "site/delete-customer",
  add_customer_company: "site/add-customer-company",
  get_customer_company: "site/get-customer-company",
  update_customer_company: "site/update-customer-company",
  add_site: "site/add-site",
  add_site_budget: "site/create-site-budget",
  get_site: "site/get-site",
  get_site_budget: "site/get-site-budget?",
  get_site_budget_analytics: "site/get-site-budget-analytics?",
  update_site: "site/edit-site",
  Delete_site: "site/delete-site",
  create_team: "site/create-team",
  get_team: "site/get-team",
  delete_team: "site/delete-team",
  update_team: "site/update-team",
  site_users: "site/site-users",
  get_user_site: "site/user-sites",
  delete_document: "site/delete-document",
  add_asset: "site/add-asset",
  get_asset: "site/get-asset",
  delete_asset: "site/delete-asset",
  delete_site_budget: "site/delete-site-budget",
  get_freezed_amount_detail: "site/get-freezed-amount-detail",

  // User
  get_dashboard_data: "user/web-dashboard",
  get_birthday_anniversary: "user/get-birthday-anniversary",
  get_user_chart: "user/get-user-status-chart",
  get_profile: "user/get-profile",
  mark_attendance: "user/mark-attendance",
  bulk_mark_attendance: "user/bulk-mark-attendance",
  get_attendance: "user/get-attendance",
  get_attendance_summary: "user/get-attendance-summary",
  delete_Od: "user/delete-odrequest",
  mark_extra_work: "user/mark-extraWork",
  get_extra_work: "user/get-extraWork",
  create_od: "user/create-odrequest",
  get_od: "user/get-odrequest?",
  get_od_details: "user/get-odrequest-detail",
  edit_od: "user/edit-odrequest",
  create_ar: "user/create-arrequest",
  get_ar: "user/get-arrequest",
  get_ar_detail: "user/get-arrequest-detail",
  edit_ar: "user/edit-arrequest",
  delete_ar: "user/delete-attendance",
  add_leave: "user/add-leave",
  get_leave: "user/get-leave",
  get_Leave_detail: "user/get-leave-detail",
  update_leave: "user/update-leave",
  delete_leave: "user/delete-leave",
  create_wfh: "user/create-wfhrequest",
  get_wfh: "user/get-wfhrequest?",
  get_wfh_details: "user/get-wfhrequest-detail?",
  update_wfh_status: "user/update-wfhrequest-status",
  delete_wfh: "user/delete-wfhrequest",
  user_status_update: "user/update-status",
  get_leave_count: "user/get-counts",
  get_logs: "user/get-logs",
  get_notification: "user/get-notification",
  get_notification_count: "user/get-notification-count",
  get_export_data: "user/get-export-data?",
  update_site_budget: "site/update-site-budget",
  get_reimbursement: "account/get-reimbursement-form",
  create_reimbursement_form: "account/create-reimbursement-form",
  update_reimbursement_form: "account/update-reimbursement-form",
  get_reimbursement_details: "account/get-reimbursement-form-detail",
  delete_reimbursement: "account/delete-reimbursement-form",
  get_site_manpower: "user/get-site-manpower",
  export_site_budget_request_data: "user/export-site-budget-request-data",

  //TaskManagement
  create_task: "task/create-task",
  update_task: "task/update-task",
  delete_task: "task/delete-task",
  get_tasks: "task/get-tasks",
  get_task_detail: "task/get-task-detail",
  add_comment: "task/add-comment",
  delete_comment: "task/delete-comment",
  create_meeting: "task/create-meeting",
  get_meetings: "task/get-meetings",
  get_meeting_detail: "task/get-meeting-detail",
  update_meeting: "task/update-meeting",
  delete_meeting: "task/delete-meeting",

  // Analytics
  get_analytics_executive: "analytics/executive",
  get_analytics_financial: "analytics/financial",
  get_analytics_sites: "analytics/sites",
  get_analytics_alerts: "analytics/alerts",
  get_analytics_activity: "analytics/activity",
  get_analytics_forecast: "analytics/forecast",
  get_analytics_vendors: "analytics/vendors",
  get_analytics_payments: "analytics/payments",
  get_analytics_drilldown: "analytics/drilldown",
  get_analytics_workorders: "analytics/workorders",
  get_analytics_profitloss: "analytics/profit-loss",
  get_analytics_gstsummary: "analytics/gst-summary",
  get_analytics_salary: "analytics/salary",
};
